import * as ActionTypes from "../action-types";

const employer_defaultState = {
  byID: {},
  allIDs: [],
  byNoCOID: {},
};

export const employer = (state = employer_defaultState, action) => {
  let newState = JSON.parse(JSON.stringify(state));
  if (!action) return newState;
  switch (action.type) {
    case ActionTypes.EMPLOYER_GET_ALL: {
      const employers = action.employer;
      employers &&
        employers.length &&
        employers.map((employer) => {
          const { memid } = employer;
          newState.byID[memid] = employer;

          if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
          return null;
        });
      return newState;
    }
    case ActionTypes.CREATE_EMPLOYER:
    case ActionTypes.UPDATE_EMPLOYER: {
      const employers = action.employer;
      const { memid } = employers;

      if (memid) {
          newState.byID[memid] = employers;

        if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
      }
      return newState;
    }
    case ActionTypes.GET_EMPLOYER_LIST_NO_COID: {
      const employers = action.employer;

      employers && employers.length && employers.map((employer) => {
        const { memid } = employer;
        newState.byNoCOID[memid] = employer;

        if (!newState.allIDs.includes(memid)) newState.allIDs.push(memid);
      })
      return newState;
    }
    case ActionTypes.UPDATE_REMARKCOUNT_EMPLOYER: {
      const remark = action.remark;

      const { refid, remarkCount } = remark;

      if (refid) {
        newState.byID[refid] = {...newState.byID[refid], remarkCount: remarkCount};
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};
